var _style, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserConfirmed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user-confirmed_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35A4DD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M42.4 923.5s-24.5-195 148.3-343.3 386.4-88.1 386.4-88.1 36.8 6.4 86.2 30.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F9AF17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M708.2 802.5l54.8 55.7L877.5 745"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9AF17",
    d: "M792.9 629.1c43.5 0 84.4 16.9 115.1 47.7 30.7 30.7 47.7 71.6 47.7 115.1S938.8 876.3 908 907c-30.7 30.7-71.6 47.7-115.1 47.7s-84.4-16.9-115.1-47.7c-30.7-30.7-47.7-71.6-47.7-115.1s16.9-84.4 47.7-115.1c30.7-30.8 71.6-47.7 115.1-47.7m0-65c-125.8 0-227.8 102-227.8 227.8 0 125.8 102 227.8 227.8 227.8s227.8-102 227.8-227.8c-.1-125.9-102.1-227.8-227.8-227.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M470.7 67.9c50.3 0 97.6 19.6 133.2 55.2 35.6 35.6 55.2 82.9 55.2 133.2s-19.6 97.6-55.2 133.2c-35.6 35.6-82.9 55.2-133.2 55.2s-97.6-19.6-133.2-55.2c-35.6-35.6-55.2-82.9-55.2-133.2s19.6-97.6 55.2-133.2c35.6-35.6 82.9-55.2 133.2-55.2m0-65c-139.9 0-253.4 113.4-253.4 253.4 0 139.9 113.4 253.4 253.4 253.4s253.4-113.4 253.4-253.4S610.6 2.9 470.7 2.9z"
  })));
}

export default SvgUserConfirmed;